import { render, staticRenderFns } from "./Messager.vue?vue&type=template&id=a95aa590"
import script from "./Messager.vue?vue&type=script&lang=js"
export * from "./Messager.vue?vue&type=script&lang=js"
import style0 from "./Messager.vue?vue&type=style&index=0&id=a95aa590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports